"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'Loading': 'Loading'
        }
    },
    'cs': {
        'translation': {
            'Loading': 'Nahrávám'
        }
    },
    'zh': {
        'translation': {
            'Loading': '载入中'
        }
    }
};
